export default (params) => ({
  trigger: {
    name: 'content_blocks.product_row.view',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'personalized_assortment',
          'recently_viewed',
          'bestsellers',
          'featured_items',
          'related_products',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'view_content',
    },
    nonInt: true,
  },
});
